/**
 * Default AI copilot suggestion questions shown across every report in the
 * "Usage & Data" group on the reports page. Centred on commitment vs usage —
 * the representative report for this group.
 */
export const USAGE_DATA_REPORT_SUGGESTIONS = [
  'How is commitment vs usage tracking overall?',
  'Which customers are projected to exceed their commitment?',
  'Who is underutilizing their commitment?',
  'Show commitments expiring soon',
  'Break down committed vs consumed by product',
];

/**
 * Report-context key sent with chat messages from Usage & Data pages. The backend maps this to
 * the group of related reports (commitment + unmetered events) and combines their tools/context,
 * so a usage / events / commitment question can be answered from all of them at once.
 */
export const USAGE_DATA_REPORT_CONTEXT = 'usage-data';
